import FormationBuilder from "./FormationBuilder/FormationBuilder";
import teams from "../AdminPortal/teamdata.json";

export default function App() {
  return (
    <FormationBuilder teamJson={teams[0]} />
  );
}
